// Real contact information for Zélia Silva — from https://zeliasilva.expportugal.com/
export const CONTACT = {
  fullName: "Zélia Silva",
  role: "Consultora imobiliária",
  association: "eXp Portugal",
  phone: "+351 967 155 498",
  phoneRaw: "+351967155498",
  whatsappUrl: "https://wa.me/351967155498",
  email: "zelia.silva@expportugal.com",
  facebook: "https://www.facebook.com/profile.php?id=100013726471446",
  instagram: "https://www.instagram.com/zelia.silva.consultora/",
  originalSiteUrl: "https://zeliasilva.expportugal.com/?lang=pt-PT",
  photo: "https://nhkxpqunzawllesgatth.supabase.co/storage/v1/object/public/agent-images/1770114434123-wvhyhi4ysaq.png",
  featuredImages: [
    "https://nhkxpqunzawllesgatth.supabase.co/storage/v1/object/public/agent-images/1772620890843-twjydesjb8.png",
    "https://nhkxpqunzawllesgatth.supabase.co/storage/v1/object/public/agent-images/1772822444943-62i73lwtyvl.png",
    "https://nhkxpqunzawllesgatth.supabase.co/storage/v1/object/public/agent-images/1772727098190-qltxxdo9lk.png",
  ],
  tagline: "Encontre a casa dos seus sonhos e transforme-a na casa com que sempre sonhou.",
  bioShort:
    "Sou a Zélia Silva, consultora imobiliária no Grande Porto, com mais de 10 anos de experiência dedicados a maximizar o valor e a experiência para os meus clientes.",
  bioLong: [
    "Sou uma profissional do setor imobiliário com mais de 10 anos de experiência dedicados a maximizar o valor e a experiência para os meus clientes — sejam eles compradores ou vendedores.",
    "O meu objetivo é simples: ajudá-lo a concretizar o seu objetivo, seja ele vender ou comprar um imóvel. Trabalho principalmente no Grande Porto — com foco em Rio Tinto, Gondomar, Porto, Maia, Ermesinde e Valongo — mas acompanho clientes em qualquer parte do país e do estrangeiro.",
    "Como consultora associada à eXp Portugal, tenho ao meu lado uma rede internacional que me permite oferecer um serviço completo: da avaliação e marketing profissional à negociação e escritura, sem esquecer o pós-venda.",
  ],
};
